import { render } from "./LoadingSpinnerNr5.vue?vue&type=template&id=2454a638&scoped=true"
import script from "./LoadingSpinnerNr5.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr5.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr5.vue?vue&type=style&index=0&id=2454a638&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2454a638"]])

export default __exports__